export default function route(page: string) {
  switch (page) {
    case 'labeling-workflows':
      import('./pages/labeling-workflow-list.js')
      return page

    case 'labeling-workflow-builder':
      import('./pages/labeling-workflow-builder.js')
      return page
  }
}
